<ng-container *ngIf="activeStep$ | async as activeStep">
  <capq-progress-bar
    *ngIf="activeStep !== 7 && activeStep !== 8 && activeStep !== 9"
    [setActiveStep]="activeStep"
  >
  </capq-progress-bar>
  <div *ngIf="showPopup">
    <div
      role="alert"
      aria-atomic="true"
      id="sessionExpiry"
      class="alert session-alert"
    >
      Your session expires in {{ sessionExpirationTime$ | async }}. Please click
      the button below to extend your session.
      <div class="margin-t-15">
        <button
          type="button"
          name="cac-extend-session"
          id="cac-extend-session"
          (click)="extend()"
        >
          Extend Session
        </button>
      </div>
    </div>
  </div>
  <div
    *ngIf="errorMessage"
    id="error-subsection"
    class="form-group divWhiteBackground pt-40"
  >
    <div
      role="alert"
      aria-atomic="true"
      [ngClass]="{
        'info-message-color info-message': errorType === 'blockedSSN',
        'alert-message-color alert-message':
          errorType === 'invalidSSN' || errorType === 'frozenBureauExists'
      }"
      class="desktop btn-actions desktop-97-5 ErrmonthlyPay errWidthL required validation-error mobileView-pb-15"
    >
      {{ errorMessage }}
    </div>

    <div
      [ngClass]="{
        'info-message-color mobile-info-message': errorType === 'blockedSSN',
        'alert-message-color mobile-alert-message':
          errorType === 'invalidSSN' || errorType === 'frozenBureauExists'
      }"
      class="mobileOnly ErrmonthlyPay errWidthL required validation-error"
    >
      {{ errorMessage }}
    </div>
  </div>
  <ng-container [ngSwitch]="activeStep">
    <ng-container *ngSwitchCase="1">
      <capq-personal [adobeScriptLoaded]="adobeScriptLoaded"></capq-personal>
      <capq-residence [adobeScriptLoaded]="adobeScriptLoaded"></capq-residence>
      <capq-income [adobeScriptLoaded]="adobeScriptLoaded"></capq-income>
      <capq-accounts [adobeScriptLoaded]="adobeScriptLoaded"></capq-accounts>
      <capq-vehicle-type
        [adobeScriptLoaded]="adobeScriptLoaded"
      ></capq-vehicle-type>
      <capq-identification
        #identification
        [adobeScriptLoaded]="adobeScriptLoaded"
        (setConsent)="updateConsent('identification', $event)"
      ></capq-identification>
      <capq-sms-consent
        *ngIf="showSmsConsent"
        (setConsent)="updateConsent('sms', $event)"
      ></capq-sms-consent>
      <capq-summary
        [adobeScriptLoaded]="adobeScriptLoaded"
        [userDealerIds]="userDealerIds"
        [smsConsentGiven]="smsConsentGiven"
        (setConsent)="updateConsent('summary', $event)"
        (resetIdentificationConsent)="resetIdentificationConsent()"
        [allConsentsGiven]="(allConsentsGiven$ | async)!"
        (activeStep)="updateActiveStep($event)"
        (submissionFailureReason)="updateFailureReason($event)"
        (ssnError)="updateSSNError($event)"
      ></capq-summary>
    </ng-container>
    <!-- TODO: handle success -->
    <capq-success-prequal
      *ngSwitchCase="7"
      [adobeScriptLoaded]="adobeScriptLoaded"
      [smsConsentGiven]="smsConsentGiven"
    ></capq-success-prequal>
    <capq-openloan
      *ngSwitchCase="8"
      [adobeScriptLoaded]="adobeScriptLoaded"
      [submissionFailureReason]="submissionFailureReason"
      [smsConsentGiven]="smsConsentGiven"
    ></capq-openloan>
    <capq-verification-required *ngSwitchCase="9"></capq-verification-required>
    <capq-error-page *ngSwitchCase="-1"> </capq-error-page>
    <div *ngSwitchDefault></div>
  </ng-container>
  <capq-product-terms *ngIf="activeStep >= 1"> </capq-product-terms>
  <aem-footer
    [hideSocialMediaIcons]="true"
    [hideTextContentList]="[
      'Language Services for NYC Residents',
      'Your Credit and Privacy'
    ]"
    [addCustomLinks]="[
      {
        text: 'Financial Privacy Policy',
        href: '/assets/documents/legal/privacy-notice.pdf'
      }
    ]"
  ></aem-footer>
</ng-container>
